export default __webpack_public_path__ + "static/media/4.963f9a9b.png";